import React from 'react';
import styled from 'styled-components';
import Panel from './Panel';
import useMonitoringData from '../hooks/useMonitoring';
import { fetchDailyDigest } from '../api/monitoringApi';

const MetricGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 12px;
`;

const Metric = styled.div`text-align: center;`;
const MetricLabel = styled.div`font-size: 12px; color: #6b7280;`;
const MetricValue = styled.div`font-size: 20px; font-weight: 700; color: #111827; margin: 4px 0;`;
const Change = styled.span`
  font-size: 13px; font-weight: 600;
  color: ${p => p.$val > 0 ? '#10b981' : p.$val < 0 ? '#ef4444' : '#6b7280'};
`;

function fmt(v) {
  if (v === null || v === undefined) return '0%';
  const sign = v > 0 ? '+' : '';
  return `${sign}${v}%`;
}

export default function DailyDigestPanel({ refreshKey }) {
  const { data, isLoading, error } = useMonitoringData(fetchDailyDigest, [refreshKey]);

  const metrics = data ? [
    { label: '신규 가입', value: data.today.new_signups, change: data.changes.signups_change },
    { label: '신규 구독', value: data.today.new_subscribes, change: data.changes.subscribes_change },
    { label: '신규 사이트', value: data.today.new_sites, change: data.changes.sites_change },
    { label: '매출', value: `₩${data.today.revenue?.toLocaleString()}`, change: data.changes.revenue_change },
    { label: 'API 요청', value: data.today.total_requests?.toLocaleString(), change: data.changes.requests_change },
    { label: '에러', value: data.today.error_count, change: data.changes.errors_change },
  ] : [];

  return (
    <Panel title="Daily Digest (오늘 vs 어제)" isLoading={isLoading} error={error}>
      <MetricGrid>
        {metrics.map((m, i) => (
          <Metric key={i}>
            <MetricLabel>{m.label}</MetricLabel>
            <MetricValue>{m.value}</MetricValue>
            <Change $val={m.change}>{fmt(m.change)}</Change>
          </Metric>
        ))}
      </MetricGrid>
    </Panel>
  );
}
